import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'components/StyledSelect/react_select';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { Dialog, Checkbox } from 'react-toolbox';
import UserSearch from 'components/UserSearch';
import RTCheckbox from 'styles/checkbox.scss';
import { urls } from 'helpers/url';

import S from 'modal.scss';

class PrintInstallerPaperworkModal extends React.Component {
  constructor(props) {
    super(props);
    this.onInstallerChange = this.onInstallerChange.bind(this);
    this.handleWhichPayRate = this.handleWhichPayRate.bind(this);
    this.state = {
      installerId: null,
      crewId: null,
      crews: [],
      errors: {},
      hideCosts: true,
    };
  }

  onHideCostsChange = value => this.setState({ hideCosts: value });
  onInstallerChange = value => this.setState({
    installerId: value.employable_id, crews: value.user_crews || [] });

  handleSubmit = () => {
    const { hideCosts, installerId, crewId } = this.state;
    const { appointment, selectInstaller, phaseId } = this.props;
    const query = {};
    if (selectInstaller && !installerId) return this.setState({ errors: { installerId: 'Please select an installer' } });
    if (appointment) query.appointment_id = appointment.id;
    if (hideCosts) query.hide_costs = hideCosts;
    if (installerId) query.installer_id = installerId;
    if (phaseId) query.phase_id = phaseId;
    if (crewId) query.crew_id = crewId || '';
    this.props.onClose();
    return window.open(urls.installerPaperwork({ query }));
  }

  handleWhichPayRate = val => this.setState({ crewId: val.value });

  handlePayId = val => this.setState({ crewId: val.value === 'i' ? null : val.value });

  renderCrewSelect = () => {
    const { crews, crewId } = this.state;
    const options = crews.map(c => ({ value: c.id, label: c.name }));
    options.unshift({ value: 'i', label: 'Installer' });
    return (<ReactSelect
      label="Which Pay Rate Doc To Use"
      placeholder={'Select Installer or Crew'}
      onChange={this.handlePayId}
      options={options}
      value={crewId || 'i'}
      required
    />);
  }

  render = () => {
    const { errors, installerId, crews } = this.state;
    const { active, onClose, selectInstaller, role } = this.props;
    const titleText = selectInstaller ? 'Installer' : 'Appointment';
    return (<Dialog
      active={active}
      className={S.modal}
      type="fullscreen"
      onEscKeyDown={onClose}
      onOverlayClick={onClose}
    >
      <IconButton
        icon="close"
        className={S.close}
        onClick={onClose}
      />
      <h5 className={S.title}>Preview Paperwork for {titleText}</h5>
      {selectInstaller && <UserSearch
        label="Installer"
        employableType={['Installer']}
        required
        onChange={this.onInstallerChange}
        error={errors.installerId}
      />}
      {installerId &&
       crews.length &&
       crews.some(c => !c.use_installer_pay) &&
       this.renderCrewSelect()}
      {role !== 'crew' ? (<Checkbox
        checked={this.state.hideCosts}
        label="Hide Costs"
        onChange={this.onHideCostsChange}
        theme={RTCheckbox}
      />) : null }
      <Button
        label="Preview"
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
    </Dialog>);
  }
}

PrintInstallerPaperworkModal.propTypes = {
  active: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  appointment: PropTypes.object,
  selectInstaller: PropTypes.bool,
  phaseId: PropTypes.number,
  role: PropTypes.string.isRequired,
};

PrintInstallerPaperworkModal.defaultProps = {
  active: false,
  onClose: () => {},
  appointment: null,
  selectInstaller: false,
  phaseId: null,
};

export default PrintInstallerPaperworkModal;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/printInstallerPaperworkModal.jsx